import { render, staticRenderFns } from "./MortgageFormStatusModal.vue?vue&type=template&id=94898492"
import script from "./MortgageFormStatusModal.vue?vue&type=script&lang=js"
export * from "./MortgageFormStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports